import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Accordion, DownloadDocs, Button, SpinnerCircular, Notification } from "@weirgroup/weir-dls";
import { GroupFormField } from "./input-fields";
import { Card } from '../../../components/Card/card';
import { BucketDataType, DownloadParamsType, GroupedReplacementPartType, ReplacementPartType } from "../../../types/bucketTypes";
import { useTranslation } from "react-i18next";
import { ADAPTERS,NON_ESCO, OTHERS, POINTS } from "../../../constants/bucket.contants";

import assetsApi from '../../../api/assets.api';
import { useDownload } from "../../../hooks/use-download";
import { ToastDataType } from "../../../types/toast.type";
import { useDarkMode } from "../../../hooks/use-darkmode";
interface Props {
  selectedAsset: BucketDataType;
  setShowAddNonEscoPart: Dispatch<SetStateAction<boolean>>;
  setShowBillOfMaterial?: Dispatch<SetStateAction<boolean>>;
  groupedReplacementParts: GroupedReplacementPartType
  fetchBucketList?: (arg?: boolean) => Promise<void>;
  toggleNonEscoForm?: (arg1: boolean, arg2: any) => void;
  toggleBillOfMaterial?: (arg1:boolean, arg2:any) =>void;
  setEditPart?: Dispatch<SetStateAction<any>>;
  setEditBill?: Dispatch<SetStateAction<any>>;
  isGuest: boolean;

}

export const ReplacementParts = (props: Props) => {
  const {
    selectedAsset,
    setShowAddNonEscoPart,
    setShowBillOfMaterial,
    groupedReplacementParts,
    fetchBucketList,
    toggleNonEscoForm,
    toggleBillOfMaterial,
    setEditPart,
    setEditBill,
    isGuest
  } = props;

  const { t } = useTranslation();

  const [accordianContent, setAccordianContent] = useState<any>();
  const [isAddingToList, setIsAddingToList] = useState<boolean>(false);
  const { isLoading, startDownload } = useDownload();

  const [showToast, setShowToast] = useState<boolean>(false)
  const [toastData, setToastData] = useState<any>()
  const {darkMode} = useDarkMode();
  const renderToastMessage = (toastData: ToastDataType) => {
    setShowToast(true);
    setToastData(toastData)
  }

  useEffect(() => {
    if (showToast) {
      setTimeout(() => setShowToast(false), 5000)
    }
  }, [showToast])

  const listA = {
    "Serial_Number": selectedAsset.serial_number,
    "Machine_Number": selectedAsset.machine_number,
    "Make": selectedAsset.make
  };

  const listB = {
    "Stock_Number": selectedAsset.stock_number,
    "Type": selectedAsset.type,
    "Model": selectedAsset.model
  };


  const downloadDocs = async () => {
    const params: DownloadParamsType = {
      asset_id: selectedAsset.asset_id,
      file_path: selectedAsset.attachment?.url
    }
    const name = selectedAsset.attachment ? selectedAsset.attachment.name : "Asset Attachment";
    startDownload(assetsApi.downloadAssetAttachment(params), name);
  }

  const attachmentInfo = () => {
    return (
      <div className="attachment-info" data-testid="attachment-info">
        {selectedAsset.attachment == null ? <></> :
          <DownloadDocs
            buttonTitle={"Download"}
            docName={selectedAsset.attachment.name}
            onBtnClick={() => downloadDocs()}
            applyModalInternalGrid={true}
            modalType={"large"}
            canvasDeviceSize={'desktop'}
          />
        }
        <div className="replacement-parts-container">
          <div className="replacement-parts-item">
            <GroupFormField list={listA} />
          </div>
          <div className="replacement-parts-item">
            <GroupFormField list={listB} />
          </div>
        </div>
      </div>
    );
  };
  const billOfMaterial = () => {
    return (
      <div className="non-esco">
        {groupedReplacementParts.BILL_OF_MATERIALS?.map((part: ReplacementPartType) => {
          return <Card
            key={part.asset_id}
            type={"replaceableParts"}
            cardInfo={part}
            nonEsco={true}
            fetchBucketList={fetchBucketList}
            editHandler={toggleBillOfMaterial}
            isGuest={isGuest}
          />
        })}
      <div className="btn-container btn-margin">
        <Button
            label={t("addNewPart")}
            size={"sm"}
            variant={"secondary"}
            onClick={showAddBillOfMaterial}
            disabled={isGuest}
          />
      </div>
      </div>
    );
  };

  const displayAccordionDropdown = (data: ReplacementPartType[]) => {
    return (
      <div className="adapters">
        {data.map((part: ReplacementPartType,) => {
          return <Card
            key={part.asset_id}
            type={"replaceableParts"}
            cardInfo={part}
            setLoader={setIsAddingToList}
            renderToastMessage={renderToastMessage}
            isGuest={isGuest}
          />
        })}
      </div>
    );
  }

  const nonEsco = () => {
    return (
      <div className="non-esco">
        {groupedReplacementParts.NON_ESCO?.map((part: ReplacementPartType) => {
          return <Card
            darkMode={darkMode}
            key={part.asset_id}
            type={"replaceableParts"}
            cardInfo={part}
            nonEsco={true}
            fetchBucketList={fetchBucketList}
            editHandler={toggleNonEscoForm}
            isGuest={isGuest}
          />
        })}
        <div className="btn-container btn-margin">
          <Button
            darkMode={darkMode}
            label={t("addNewPart")}
            size={"sm"}
            variant={"secondary"}
            onClick={showAddnewPart}
            disabled={isGuest}
          />
        </div>
      </div>
    )
  }

  const showAddnewPart = () => {
    if (setEditPart) {
      setEditPart(undefined);
    }
    setShowAddNonEscoPart(true);
  }
  const showAddBillOfMaterial = () => {
    if (setEditBill) {
      setEditBill(undefined);
    }
    setShowBillOfMaterial?.(true);
  }

  useEffect(() => {
    let accordianData = [
      {
        content: attachmentInfo(),
        title: t("rmation"),
      }
    ]
    const keys = Object.keys(groupedReplacementParts);
    if (keys.includes(POINTS)) {
      accordianData.push(
        {
          content: displayAccordionDropdown(groupedReplacementParts.POINTS ? groupedReplacementParts.POINTS : []),
          title: t("points"),
        }
      )
    }

    if (keys.includes(ADAPTERS)) {
      accordianData.push(
        {
          content: displayAccordionDropdown(groupedReplacementParts.ADAPTERS ? groupedReplacementParts.ADAPTERS : []),
          title: t("adapters"),
        }
      )
    }

    if (keys.includes(OTHERS)) {
      accordianData.push(
        {
          content: displayAccordionDropdown(groupedReplacementParts.OTHERS ? groupedReplacementParts?.OTHERS : []),
          title: t("others"),
        }
      )
    }

    if (keys.includes(NON_ESCO)) {
      accordianData.push(
        {
          content: nonEsco(),
          title: t("nonEsco"),
        }
      )
    }
    if(selectedAsset.bucket_type.toLowerCase() === 'non-esco'){
      accordianData.push({
        content: billOfMaterial(),
        title: t("billOfMaterials"),
      })
    }

    setAccordianContent(accordianData);
  }, [groupedReplacementParts])



  return (
    <div className="replacement-parts" data-testid="replacement-parts">
      {isLoading || isAddingToList ?
        <div className="spinner">
          <SpinnerCircular darkMode={darkMode}/>
          <p>{t("loading")}</p>
        </div> : <></>}
      <Accordion
        darkMode={darkMode}
        accordianContent={accordianContent}
        canvasDeviceSize={"none"}
      />
      {showToast ? <div className="toast">
        <Notification 
          darkMode={darkMode}
          title={toastData.variant == "success" ? "Success" : "Fail"}
          textContent={toastData.message}
          variant={toastData.variant}
          onClose={()=>{setShowToast(false)}}
        />
      </div> : <></>}
    </div>
  );
};